import CollapseableSectionContainer from './collapseable_section_container';

const CollapseableSection = CollapseableSectionContainer;

export default CollapseableSection;
